import { Component, Prop } from 'vue-property-decorator';
import Vue, { VNode } from 'vue';
import { Button } from 'vant';
import { Toast } from '@hb/coffee';
import IconSvg from '@/components/Icon-svg';
import SmsCountdown from '@/shared/utils/SmsCountdown';
import { SUNING_COMMODITY } from '@/shared/commodity';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'SMSDialog' })
export default class SMSDialog extends Vue {
  $refs!: {
    smsTxt: HTMLInputElement;
  };

  @Prop({
    type: String,
    default: '确认',
  })
  private label!: string;

  // 是否有再发送
  @Prop({
    type: Boolean,
    default: true,
  })
  private hasResend!: boolean;

  @Prop()
  private productId!: string;

  private visible = true;

  private countDown = new SmsCountdown();

  // 是否是提现申请页
  private get isApplyPage() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.$route && this.$route.meta.pageId === '臻有钱_提现申请页';
  }

  private get suNingProductId() {
    return this.productId === SUNING_COMMODITY;
  }

  public show(): void {
    this.visible = true;
    this.reset();
  }

  public onVisible(): void {
    this.visible = false;
  }

  public validate(): boolean {
    if (!(this.$refs.smsTxt && /^[0-9]{4,6}$/.test(this.$refs.smsTxt.value))) {
      Toast('请输入正确的验证码');
      return false;
    }

    return true;
  }

  private reset(): void {
    this.countDown.reset();

    Vue.nextTick(() => {
      this.$refs.smsTxt.value = '';
    });
  }

  private created() {
    // 区分提现和还款的埋点
    if (this.isApplyPage) {
      if (this.suNingProductId) {
        this.$ubtModuleExpose(
          'finance_withdrawal_preMessage',
          'commodityId',
          this.productId,
        );
      } else {
        this.$ubtPageButton(
          '臻有钱_提现申请_后置短信校验弹窗',
          'commodityId',
          this.productId,
        );
      }
    } else {
      this.$ubtPageButton(
        '臻有钱_还款_短信校验弹窗',
        'commodityId',
        this.productId,
      );
    }
    if (this.countDown.isRunning) {
      return;
    }
    if (this.suNingProductId) {
      this.countDown.start();
    }
  }

  private render() {
    return (
      <van-dialog
        class={style.BaseRepayDailog}
        v-model={this.visible}
        v-class
        show-confirm-button={false}
        title={'输入验证码'}
      >
        <IconSvg
          class={style.dialogClose}
          iconClass="cross"
          onClick={this.close.bind(this)}
        />
        {this.renderSMS()}
        <Button
          type="primary"
          size="large"
          onClick={this.onSubmit.bind(this)}
          class={style.dialogSubmit}
        >
          {this.label}
        </Button>
      </van-dialog>
    );
  }

  private close(): void {
    this.visible = false;
    this.$ubtPageButton('臻有钱_提现申请_短信校验弹窗_关闭');
    this.$emit('close');
  }

  private onClickSms(): void {
    if (!this.countDown.isRunning) {
      this.countDown.start();
      this.sendSms();
    }
  }

  private sendSms(): void {
    this.$emit('sendSms');
  }

  private onSubmit(): void {
    const smsCode = this.$refs.smsTxt.value || '';

    if (this.validate()) {
      this.$emit('submit', smsCode);
    }
  }

  private onBlurFixed(): void {
    window.scrollTo(0, 0);
    document.body.scrollTop = document.body.scrollHeight;
  }

  private renderSMS(): VNode {
    return this.renderRow({
      label: '短信验证码',
      value: (
        <div class={style.smsRow}>
          <input
            ref="smsTxt"
            class={style.smsInput}
            maxlength="6"
            placeholder="输入短信验证码"
            type="tel"
            pattern=""
            onblur={() => this.onBlurFixed()}
          />
        </div>
      ),
    });
  }

  private renderRow(row: { label: string; value: string | VNode }): VNode {
    return (
      <div class={style.dialogRow}>
        <span class={style.Label}>{row.label}</span>
        <span class={style.Value}>{row.value}</span>
        {this.hasResend && (
          <span onClick={this.onClickSms.bind(this)} class={style.smsBtn}>
            {this.countDown.reSend}
          </span>
        )}
      </div>
    );
  }
}
